<template>
  <div class="good-info-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="base-info group">
          <div class="basic">
            <!-- <span>*</span> -->
            基本信息
          </div>
          <el-form
            ref="form"
            :rules="rules"
            :model="baseInfo"
            label-width="80px"
            label-position="right"
            class="good-form base-info-form"
          >
            <el-form-item label="产品名称" prop="name" class="form-item">
              <el-input
                placeholder="请输入产品名称"
                v-model="baseInfo.name"
                class="good-input"
              ></el-input>
              <!-- <span class="tip">产品名称不要超过一百个字</span> -->
            </el-form-item>
            <el-form-item label="产品别名" class="form-item">
              <div class="alias-list">
                <div
                  class="alias-item"
                  v-for="(item, index) in baseInfo.alias"
                  :key="index"
                >
                  <el-input
                    placeholder="请输入"
                    v-model="baseInfo.alias[index]"
                    class="good-input"
                    style="width: 185px"
                  >
                  </el-input>
                  <div
                    class="el-icon-error delete-icon"
                    @click="handleDeleteAlias(index)"
                  ></div>
                </div>
                <span class="add-btn" @click="handleAddAlias">+添加别名</span>
              </div>
            </el-form-item>
            <el-form-item label="关联品牌" prop="brand" class="form-item">
              <el-select
                placeholder="请选择"
                v-model="baseInfo.brand"
                class="good-input"
                style="width: 185px"
                @change="changeBrand"
              >
                <el-option
                  v-for="item in brandList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.brandName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌系列" prop="series" class="form-item">
              <el-select
                v-model="baseInfo.series"
                class="good-input"
                style="width: 185px"
                placeholder="请选择"
              >
                <el-option
                  :value="item.id"
                  :label="item.seriesName"
                  v-for="item in seriesList"
                  :key="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产品图片" class="form-item" prop="masterPic">
              <p class="tips" style="margin-bottom: 8px">
                建议尺寸：600*600，图片类型jpg、png
              </p>
              <div class="img-box">
                <imgUpLoader
                  :max-pic-num="1"
                  @getPics="getMasterImgList"
                  :index="0"
                  text="主图"
                  :imgUrl="baseInfo.masterPic"
                />
              </div>
            </el-form-item>
            <!-- <el-form-item
              label="排序"
              prop="baseMonthlySales"
              class="form-item"
            >
              <el-input
                placeholder="请输入排序"
                v-model="baseInfo.baseMonthlySales"
                class="good-input"
                style="width: 185px"
              >
              </el-input>
            </el-form-item> -->
            <el-form-item label="参考价格" prop="price" class="form-item">
              <el-input
                placeholder="请输入参考价格"
                v-model="baseInfo.price"
                class="good-input"
                style="width: 185px"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="base-info group">
          <el-form
            class="good-form base-info-form"
            label-width="80px"
            label-position="right"
          >
            <el-form-item label="版本" class="form-item">
              <el-select
                placeholder="请选择"
                v-model="baseInfo.milkVersion"
                class="good-input"
                style="width: 185px"
              >
                <el-option
                  v-for="item in version"
                  :key="item.id"
                  :value="item.id"
                  :label="item.labelName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="奶源" class="form-item">
              <el-select
                placeholder="请选择"
                v-model="baseInfo.milkSource"
                class="good-input"
                style="width: 185px"
              >
                <el-option
                  v-for="item in source"
                  :key="item.id"
                  :value="item.id"
                  :label="item.labelName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产地" class="form-item">
              <el-select
                placeholder="请选择"
                v-model="baseInfo.milkOrigin"
                class="good-input"
                style="width: 185px"
              >
                <el-option
                  v-for="item in locality"
                  :key="item.id"
                  :value="item.id"
                  :label="item.labelName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="类别" class="form-item">
              <el-select
                placeholder="请选择"
                v-model="baseInfo.milkCategory"
                class="good-input"
                style="width: 185px"
              >
                <el-option
                  v-for="item in category"
                  :key="item.id"
                  :value="item.id"
                  :label="item.labelName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="规格" class="form-item">
              <el-select
                placeholder="请选择"
                v-model="baseInfo.milkSpecification"
                class="good-input"
                style="width: 185px"
              >
                <el-option
                  v-for="item in specification"
                  :key="item.id"
                  :value="item.id"
                  :label="item.labelName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="适用年龄" class="form-item">
              <el-select
                placeholder="请选择"
                v-model="baseInfo.milkRecommendedAge"
                class="good-input"
                style="width: 185px"
              >
                <el-option
                  v-for="item in age"
                  :key="item.id"
                  :value="item.id"
                  :label="item.labelName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="段位" class="form-item">
              <el-select
                placeholder="请选择"
                v-model="baseInfo.milkStage"
                class="good-input"
                style="width: 185px"
              >
                <el-option
                  v-for="item in stage"
                  :key="item.id"
                  :value="item.id"
                  :label="item.labelName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="base-info group">
          <el-form
            class="good-form base-info-form"
            label-width="80px"
            label-position="right"
          >
            <el-form-item label="厂家" class="form-item">
              <el-input
                placeholder="请输入厂家"
                v-model="baseInfo.manufacturer"
                class="good-input"
                style="width: 185px"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="注册号" class="form-item">
              <el-input
                placeholder="请输入配方注册号"
                v-model="baseInfo.regNo"
                class="good-input"
                style="width: 185px"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="运营商" class="form-item">
              <el-input
                placeholder="请输入运营商"
                v-model="baseInfo.serviceProvider"
                class="good-input"
                style="width: 185px"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="base-info group">
          <!-- <div class="basic">
            产品说明
          </div> -->
          <div class="remarks">
            <el-form
              class="good-form"
              label-width="80px"
              label-position="right"
            >
              <el-form-item label="配料表" class="form-item">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入配料表"
                  v-model="baseInfo.ingredientList"
                  class="remarks-input"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="奶粉点评" class="form-item">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入奶粉点评"
                  v-model="baseInfo.milkReview"
                  class="remarks-input"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="奶源点评" class="form-item">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入奶源点评"
                  v-model="baseInfo.sourceReview"
                  class="remarks-input"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="原料点评" class="form-item">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入原料点评"
                  v-model="baseInfo.materialReview"
                  class="remarks-input"
                >
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="base-info group">
          <!-- <div class="basic">
            产品说明
          </div> -->
          <div class="remarks">
            <el-form
              class="good-form"
              label-width="80px"
              label-position="right"
            >
              <el-form-item label="产品总结" class="form-item">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入产品总结"
                  v-model="baseInfo.summary"
                  class="remarks-input"
                >
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="btn-box">
          <button class="cancel-btn" @click="handleCancel">取消</button>
          <button class="confirm-btn" @click="handleConfirm">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import imgUpLoader from '../../components/goods/imgUpLoader';
import Header from '../../components/common/header';
export default {
  components: { imgUpLoader, Header },
  name: 'goods-lock',
  data() {
    return {
      loading: 0,
      title: {
        // 页面标题
        firstTitile: '产品管理',
        secondTitle: '产品详情'
      },
      goodsInfo: {},
      rules: {
        name: [
          {
            required: true,
            message: '请输入产品名称',
            trigger: 'blur'
          },
          {
            max: 100,
            message: '产品名称不能超过一百个字',
            trigger: 'blur'
          }
        ],
        brand: [
          {
            required: true,
            message: '请输入产品品牌',
            trigger: 'change'
          }
        ],
        series: [
          {
            required: true,
            message: '请输入产品系列',
            trigger: 'change'
          }
        ],
        masterPic: [
          {
            required: true,
            message: '请上传主图图片',
            trigger: 'change'
          }
        ],
      },
      id: null,
      baseInfo: {
        name: '',
        brand: null,
        series: null,
        masterPic: '',
        price: null,
        status: null,

        milkVersion: null,  // 奶粉版本
        milkSource: null, // 奶源地
        milkOrigin: null, // 产地
        milkCategory: null, // 类别
        milkSpecification: null,  //规格
        milkRecommendedAge: null, //适用年龄

        ingredientList: '', // 配料表
        milkReview: '', // 奶粉点评
        sourceReview: '',// 奶源点评
        materialReview: '',// 原料点评
        milkStage: null, //段位

        manufacturer: '', // 厂家
        regNo: '', // 注册号
        serviceProvider: '', // 运营商

        ingredientUnit: '',

        advantage: '',
        nutritionalAnalysisNormal: '',
        nutritionalAnalysisFortify: '',

        ingredientTable: [],
        summary: '',

        customFields: [],


        alias: ['']
      },
      brandList: [],
      seriesList: [],

      version: [],
      source: [],
      locality: [],
      category: [],
      specification: [],
      age: [],
      stage: []
    };
  },
  computed: {},
  async mounted() {
    this.getBrandList();
    this.getLabelItem();
    let query = this.$route.query;
    if (query && query.id) {
      this.id = query.id;
      this.getGoodDetail(query.id);
    }
  },
  methods: {
    // 获取产品信息
    getGoodDetail(id) {
      this.loading++;
      this.httpGet(this.$root.getGoodInfo, { id }).then(
        (res) => {
          this.loading--;
          let baseInfo = { ...this.baseInfo };
          for (let key in baseInfo) {
            baseInfo[key] = res[key];
          }
          baseInfo.alias = (res.alias || '').split(',') || [''];
          this.baseInfo = { ...baseInfo };
          this.id = res.id;
          this.getSeriesList();
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getBrandList() {
      this.loading++;
      this.httpGet(this.$root.getBrandList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter,
      }).then(
        (res) => {
          this.loading--;
          this.brandList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    changeBrand(val){
      // console.log(val);
      this.getSeriesList();
    },
    getSeriesList(){
      this.loading++;
        this.httpGet(this.$root.getSeriesList, {
          brandId: this.baseInfo.brand
        }).then(
          (res) => {
            this.loading--;
            this.seriesList = res;
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
    },
    getLabelItem(){
      this.getLabelItemByName('version');
      this.getLabelItemByName('source');
      this.getLabelItemByName('locality');
      this.getLabelItemByName('category');
      this.getLabelItemByName('specification');
      this.getLabelItemByName('age');
      this.getLabelItemByName('stage');
    },
    getLabelItemByName(dataName){
      this.loading++;
      this.httpGet(this.$root.getLabelItem, {
        dataName
      }).then(
        (res) => {
          this.loading--;
          this[dataName] = res;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 取消
    handleCancel() {
      this.$router.push({ name: 'goodsManage' });
    },
    getMasterImgList(index, val) {
      if (val === '') {
        this.baseInfo.masterPic = null;
      } else {
        this.baseInfo.masterPic = val;
      }
      this.$refs.form.clearValidate(['masterPic']);
    },
    // 下一步
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.addGood();
        } else {
          this.$message({
            message: '请填写产品信息',
            type: 'warning'
          });
        }
      });
    },
    // 添加产品
    addGood() {
      // 请求数据
      let inputData = {
        ...this.baseInfo,
        alias: this.baseInfo.alias.filter(item => item).join(',') || ''
      };
      inputData.price = +inputData.price || 0;
      // 是否为编辑产品
      let method = 'httpPost';
      if (this.id) {
        method = 'httpPut';
        inputData.id = this.id;
      }
      this.loading++;
      this[method](
        this.id ? this.$root.updateGood : this.$root.addGood, // 添加产品 or 创建产品
        inputData
      ).then(
        (res) => {
          this.$message({
            message: this.id ? '产品修改成功' : '产品创建成功',
            type: 'success'
          });
          this.loading--;
          this.$router.push({
            name: 'goodsManage'
          });
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    addOption() {
      this.optionList.push({
        name: '',
        value: ''
      });
    },
    handleAddAlias(){
      this.baseInfo.alias.push('');
    },
    handleDeleteAlias(index){
      this.baseInfo.alias.splice(index, 1);
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.good-info-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      // background: white;
      box-sizing: border-box;
      padding: 0 20px 24px;
      border-radius: 2px;

      .group {
        background: white;
        padding: 10px 0;
        margin-bottom: 10px;
        .basic {
          height: 48px;
          line-height: 48px;
          font-size: 20px;
          text-indent: 20px;
          // margin-top: 20px;
          color: gray3;
          flex-x(flex-start);

          span {
            // color: red;
            color: gray6;
            margin-right: 3px;
          }
        }
      }

      .base-info {
        // margin-bottom: 10px;
        background: white;

        .good-form {
          padding: 20px 0 30px;

          .img-box {
            flex-x(flex-start);
          }
        }

        .base-info-form {
          margin-left: 90px;
        }

        .alias-list{
          min-height: 40px;
          flex-x(flex-start, flex-start);
          flex-wrap: wrap;
          .alias-item{
            position: relative;
            margin-right: 16px;
            margin-bottom: 8px;
            .delete-icon{
              position: absolute;
              right: -8px;
              top: -8px;
              cursor: pointer;
              word(18px, #999);
            }
          }
          .add-btn{
            width: auto;
            height: 40px;
            background: transparent;
            margin: 0;
            word(14px, #5283FF);
            cursor: pointer;
          }
        }

        .good-input {
          width: 620px;
        }

        .tip {
          font-size: 14px;
          color: gray6;
          margin-left: 16px;
        }

        .red {
          color: red;
        }

        .option-box {
          background: #F7F8FA;
          padding: 0 24px;
          border-radius: 2px;
          border: 1px solid #E8E8E8;
          // height: 32px;
          overflow: hidden;

          .option-item {
            flex-x(flex-start);
            height: 40px;

            &.option-head {
              height: 32px;
            }

            input {
              height: 32px;
              background: #fff;
              border: 1px solid #E8E8E8;
              box-sizing: border-box;
            }

            .cell1 {
              width: 330px;

              input {
                width: 310px;
                padding: 0 10px;
                box-sizing: border-box;
              }
            }

            .cell2 {
              input {
                width: 500px;
                padding: 0 10px;
                box-sizing: border-box;
              }
            }
          }

          .option-btn {
            width: 94px;
            height: 32px;
            border: 1px solid #E8E8E8;
            box-sizing: border-box;
            background: #fff;
            flex-x(center);
            font-size: 14px;
            border-radius: 2px;
            cursor: pointer;
            margin-top: 12px;
            margin-bottom: 16px;
          }
        }

        .row{
          flex-x(flex-start);
          .item{
            height: 66px;
            flex-x(flex-start);
            .label{
              width: 200px;
              margin-right: 36px;
              text-align: right;
            }
          }
        }
        .parameter-box{
          flex-x(flex-start);
          flex-wrap: wrap;
          padding: 15px 0;
          .parameter-item{
            margin-top: 10px;
            flex-x();
            .label{
              margin-right: 30px;
              width: 110px;
              text-align: right;
            }
            .input-box{
              background: #FAFAFA;
              height: 60px;
              flex-x();
              padding: 0 12px;
              border-radius: 5px;
              .name{
                margin-right: 5px;
                width: 120px;
              }
              .value{
                width: 420px;
              }
              .icon{
                margin-left: 8px;
                word(18px, #999);
              }
            }
          }
        }
        .add-btn{
          width: 88px;
          height: 32px;
          background: #40B98F;
          border-radius: 3px;
          flex-x(center);
          word(14px, #fff);
          margin-left: 140px;
        }
      }

      .good-specs-box {
        .good-specs {
          // padding: 20px;
          // border: 1px solid gray9;
          margin: 30px 70px 0 60px;
        }
      }

      .remarks {
        width: 100%;
        padding-left: 95px;
        box-sizing: border-box;

        .remarks-input {
          max-width: 600px;

          textarea {
            font-size: 14px;
            max-width: 600px;
          }
        }

        .form-item{
          margin-bottom: 30px !important;
        }

        .good-detail {
          padding-left: 82px;
        }
      }

      .good-detail {
        padding-bottom: 50px;
      }
    }
  }

  .btn-box {
    background: white;
    width: 100%;
    flex-x(center);
    height: 100px !important;
    flex-shrink: 0;
    // padding-bottom: 48px;

    .cancel-btn {
      width: 96px;
      height: 40px;
      cancel-btn();
      // border-radius: 23px;
    }

    .confirm-btn {
      width: 96px;
      height: 40px;
      margin-left: 20px;
      confirm-btn();
    }
  }
}
</style>
